import { waitForElement } from '../base.js'
import { headerLayout } from '../../config.js'
import { initNavigation1 } from './header-1/navigation.js'
import { initNavigation2 } from './header-2/navigation.js'

export const initNavigation = () => {
    addWidthToMenuLevel2()
    addSocials()
    addContactInfo()

    if (headerLayout === 1) {
        initNavigation1()
    } else if (headerLayout === 2) {
        initNavigation2()
    } else {
        console.error('Invalid header layout:', headerLayout)
    }
}

// Shared functions
function addWidthToMenuLevel2() {
    const container = $('.navigation-wrapper')

    document.documentElement.style.setProperty('--menu-level-2-width', `${container.width()}px`)
}

function addSocials() {
    const socials = $('#footer .social-icons:first').clone()

    waitForElement('#navigation .navigation-in', () => {
        $('#navigation .navigation-in').append(socials)
    })
}

function addContactInfo() {
    const topNavBarClone = $('.top-navigation-bar').clone()
    const elementsToRemove = ['.top-navigation-info-bar', '.top-navigation-menu', '.top-navigation-tools']

    elementsToRemove.forEach((selector) => {
        topNavBarClone.find(selector).remove()
    })

    topNavBarClone.appendTo('#navigation .navigation-in')
}